import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IManagerProfile, IManagerProfileAuftragResponseDto } from "../types/Types";

/**
 * @author mb
 */
export const ManagerAPI = createApi({
    reducerPath: "managerAPI",
    baseQuery: fetchBaseQuery(
        {
            baseUrl: process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + "manager",
            credentials: 'include'
        }),
    tagTypes: ['managerAPI'], // for caching
    endpoints: (builder) => ({
        getManagerProfile: builder.mutation<IManagerProfile, string>(
            {
                query: (uid) => ({
                    url: 'profile/' + uid,
                    method: 'get',
                    credentials: 'include'
                })
            }
        ),
        getManagerProfileListe: builder.mutation<IManagerProfile[], void>(
            {
                query: () => ({
                    url: 'profile/',
                    method: 'get',
                    credentials: 'include'
                })
            }
        ),
        createOrUpdateManagerProfile: builder.mutation<IManagerProfile, IManagerProfile>(
            {
                query: (dto) => ({
                    url: 'profile/',
                    method: 'put',
                    credentials: 'include',
                    body: dto,
                })
            }
        ),
        getManagerProfileAuftraegeListe: builder.mutation<IManagerProfileAuftragResponseDto[], void>(
            {
                query: (uid) => ({
                    url: 'profile/' + uid + '/auftraege',
                    method: 'get',
                    credentials: 'include'
                })
            }
        ),
        changeMitarbeiterBeiAuftrag: builder.mutation<void, { uid_profile: string , uid_auftraege: string[] }>(
            {
                query: (dto) => ({
                    url: 'changeMitarbeiterBeiAuftrag',
                    method: 'post',
                    credentials: 'include',
                    body: dto,
                })
            }
        ),
        
    })
});

export const {

    useGetManagerProfileMutation,
    useGetManagerProfileListeMutation,
    useCreateOrUpdateManagerProfileMutation,
    useGetManagerProfileAuftraegeListeMutation,
    useChangeMitarbeiterBeiAuftragMutation,

} = ManagerAPI;
